/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrTemplateHeader } from './igr-template-header';
import { TemplateHeader } from './TemplateHeader';
import { TypeRegistrar } from "igniteui-react-core";
var IgrTemplateHeaderModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrTemplateHeaderModule() {
    }
    IgrTemplateHeaderModule.register = function () {
        TypeRegistrar.registerCons("IgrTemplateHeader", IgrTemplateHeader);
        TypeRegistrar.register("TemplateHeader", TemplateHeader.$type);
    };
    return IgrTemplateHeaderModule;
}());
export { IgrTemplateHeaderModule };
//# sourceMappingURL=igr-template-header-module.js.map
